import { StorageService } from '../services/storage';

const API_URL = import.meta.env.VITE_API_URL;
const STORAGE_KEY_TOKEN = 'authToken';

export const request = async ({ method, url, data = null, isFormData = false, custom_headers = {}, token = null }) => {
	const apiUrl = `${API_URL}${url}`;
	const authToken = token || StorageService.getItem(STORAGE_KEY_TOKEN);
	const headers = {
		Accept: ['application/json', 'text/plain'],
		accessKey: authToken,
		...custom_headers,
	};

	if (!isFormData) {
		headers['Content-Type'] = 'application/json';
	}

	const options = {
		method,
		headers: new Headers(headers),
		mode: 'cors',
	};

	if (data !== null) {
		options.body = isFormData ? data : JSON.stringify(data);
	}

	try {
		const response = await fetch(apiUrl, options);

		// Handle non-successful responses (e.g., 404, 500, etc.)
		if (!response.ok) {
			throw new Error(`HTTP Error: ${response.status}`);
		}

		// Check if the response has content
		const contentType = response.headers.get('Content-Type');
		if (contentType && contentType.includes('application/json')) {
			return response.json(); // Only parse JSON if response has JSON content type
		} else {
			return response.ok; // Otherwise return status text or some other placeholder
		}
	} catch (error) {
		// Handle network errors and exceptions
		console.error(`Error calling ${apiUrl}:`, error);
		throw error;
	}
};
